angular.module('env.custom.customDirective', [])

    .constant('CUSTOM_DIRECTIVE', {
        CD: "cd", // name of our `custom-directive-resolving` directive
        CD_WRAPPER: "cd-wrapper", // name of wrapper directive (current one).
        CD_NAME: "cd-name", // name of attribute for custom directive alias
        CD_TYPE: "cd-type", // name of attribute for custom directive restrict type (C, E or A)
        CD_VALUE: "cd-value", // name of attribute for value of custom attribute
        CD_CUSTOM_NAME: "cd-custom-name", // name of attribute for resolved custom directive name
        DEFAULT_TAG: "div" // replacement tag for error situations
    })

    .directive('cd', function ($compile, $log, customResourceResolver, CUSTOM_DIRECTIVE) {

        var compile = function (element) {

            var cdName = element.attr(CUSTOM_DIRECTIVE.CD_NAME); // custom directive alias
            var cdValue = element.attr(CUSTOM_DIRECTIVE.CD) || ''; // custom directive value

            var cdType = 'a'; // custom directive type (E, A or C)
            if (element.prop("tagName").toUpperCase() == CUSTOM_DIRECTIVE.CD.toUpperCase()) { // is element
                cdType = 'e'
            } else if (angular.isDefined(element.attr(CUSTOM_DIRECTIVE.CD))) { // is attribute
                cdType = 'a';
            } else if (element.hasClass(CUSTOM_DIRECTIVE.CD)) { // is class
                cdType = 'c';
            }

            if (angular.isUndefined(cdName) || !angular.isString(cdName)) {
                $log.error("'" + CUSTOM_DIRECTIVE.CD + "' directive must have '" + CUSTOM_DIRECTIVE.CD_NAME + "' attribute");
                return;
            }

            var wrapper = $('<' + CUSTOM_DIRECTIVE.CD_WRAPPER + '></' + CUSTOM_DIRECTIVE.CD_WRAPPER + '>');
            wrapper.attr(CUSTOM_DIRECTIVE.CD_NAME, cdName);
            wrapper.attr(CUSTOM_DIRECTIVE.CD_TYPE, cdType);
            if (cdValue && cdValue != '') {
                wrapper.attr(CUSTOM_DIRECTIVE.CD_VALUE, cdValue);
            }

            element.removeAttr(CUSTOM_DIRECTIVE.CD);
            element.removeClass(CUSTOM_DIRECTIVE.CD);
            element.removeAttr(CUSTOM_DIRECTIVE.CD_NAME);
            if (cdType == 'e') {
                element = element.changeTagName(CUSTOM_DIRECTIVE.DEFAULT_TAG);
            }

            element = element.wrap(wrapper);

            var fn = $compile(element.parent()); // compiling again

            return function (scope) {
                fn(scope);
            }

        };

        return {
            priority: 1001, // compiles first
            terminal: true, // prevent lower priority directives to compile after it
            restrict: 'EAC', // elements, attributes and classes
            compile: compile
        };
    })

    .directive('cdWrapper', function () {
        return {
            restrict: 'E',
            controller: function ($scope, $element, $compile, $log, customResourceResolver, CUSTOM_DIRECTIVE) {

                var recompile = function () {
                    var cdName = $element.attr(CUSTOM_DIRECTIVE.CD_NAME); // custom directive alias
                    var cdType = $element.attr(CUSTOM_DIRECTIVE.CD_TYPE); // custom directive type (E, A or C)
                    var cdCustomName = $element.attr(CUSTOM_DIRECTIVE.CD_CUSTOM_NAME); // custom directive resolved name
                    var cdValue = $element.attr(CUSTOM_DIRECTIVE.CD_VALUE) || ''; // custom directive name
                    var cdResolved = angular.isDefined(cdCustomName) && angular.isString(cdCustomName); // true, if custom directive is resolved

                    customResourceResolver.resolveDirective(cdName).then(function (cdNewCustomName) {
                        var cdNewResolved = angular.isDefined(cdNewCustomName) && angular.isString(cdNewCustomName);
                        if (cdNewCustomName == cdCustomName) { // if directive not changed
                            return;
                        }

                        var firstChild = $element.children(":first");
                        if (!firstChild) {
                            return;
                        }

                        if (cdNewResolved) { // new name was resolved
                            if (cdType == 'e') {
                                firstChild = firstChild.changeTagName(cdNewCustomName);
                            } else if (cdType == 'a') {
                                if (cdResolved) {
                                    cdValue = firstChild.attr(cdCustomName) || cdValue;
                                    firstChild.removeAttr(cdCustomName); // remove old attr
                                }
                                firstChild.attr(cdNewCustomName, cdValue || '');
                            } else if (cdType == 'c') {
                                if (cdResolved) {
                                    firstChild.removeClass(cdCustomName);
                                } // remove old class
                                firstChild.addClass(cdNewCustomName);
                            }
                        } else { // if custom directive not found
                            if (!cdResolved) {
                                return; // old one was not set up, new one was not resolved
                            }

                            if (cdType == 'e') {
                                firstChild = firstChild.changeTagName(CUSTOM_DIRECTIVE.DEFAULT_TAG);
                            } else if (cdType == 'a') {
                                cdValue = firstChild.attr(cdCustomName) || cdValue;
                                $element.attr(CUSTOM_DIRECTIVE.CD_VALUE, cdValue || '');
                                firstChild.removeAttr(cdCustomName);
                            } else if (cdType == 'c') {
                                firstChild.removeClass(cdCustomName);
                            }
                        }

                        $compile(firstChild)($scope);
                    });
                };

                // todo: raise recompile when condition object will changed

                recompile();
            }
        };
    })
;